import accounting from "accounting";
import moment from "moment";
import React from "react";

import { currencySymbol } from "../../../../../../util/constantsToOptions";
import MultiColStyledField from "./MultiColStyledField";
import usePlacementContext from "./usePlacementContext";

export const formatDate = (date) => moment(date).format("MMM D, YYYY");

export function PayoutConversionRate() {
  const {
    payoutConversionCurrency, payoutConversionRate, payoutCompletedAt
  } = usePlacementContext();

  const payoutCurrency = payoutConversionCurrency || "USD";

  if (payoutCurrency === "USD") return null;

  const conversion = `$1.00 USD : ${
    accounting.formatMoney(payoutConversionRate, {
      symbol: currencySymbol(payoutCurrency) })
  } ${payoutCurrency}`;

  const tooltip = `$1.00 USD = ${
    accounting.formatMoney(payoutConversionRate, { symbol: currencySymbol(payoutCurrency) })
  } ${payoutCurrency} on ${formatDate(payoutCompletedAt)}`;

  return (
    <MultiColStyledField
      label="Conversion Rate:"
      tooltip={tooltip}
      value={conversion}
      underline
    />
  );
}

export function EarningsConversionRate() {
  const { salaryCurrency, usdConversion, createdAt } = usePlacementContext();

  if (salaryCurrency === "USD") return null;

  const conversion =
  `${
    accounting.formatMoney(1, { symbol: currencySymbol(salaryCurrency) })
  } ${salaryCurrency} : ${(
    accounting.formatMoney(usdConversion, { symbol: currencySymbol("USD") })
  )} USD`;

  const tooltip =
  `${
    accounting.formatMoney(1, { symbol: currencySymbol(salaryCurrency) })
  } ${salaryCurrency} = $${usdConversion} USD on ${formatDate(
    createdAt
  )}`;

  return (
    <MultiColStyledField
      label="Conversion Rate:"
      tooltip={tooltip}
      value={conversion}
      underline
    />
  );
}
